import { authMeSchema, performanceSchema } from "../schemas/index.js";
export class AuthResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /** Introspect the current credential: key type, can_execute, limits, credits. */
    me() {
        return this.http.request({
            method: "GET",
            path: "/auth/me",
            endpoint: "auth.me",
            dataSchema: authMeSchema,
        });
    }
    /**
     * `GET /auth/performance` — the OM-native, fresh P&L analytics endpoint (Round-2,
     * live 2026-07-15). Currency-partitioned totals + per-group buckets. `group_by=none`
     * gives portfolio totals; `group_by=day` gives per-day buckets (not date-sorted).
     */
    performance(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/auth/performance",
            endpoint: "auth.performance",
            query: { group_by: params.group_by, from: params.from, to: params.to },
            dataSchema: performanceSchema,
        });
    }
}
//# sourceMappingURL=auth.js.map